import { render } from "./navigation-bullets.vue?vue&type=template&id=017f74fe&scoped=true"
const script = {}

import "./navigation-bullets.vue?vue&type=style&index=0&id=017f74fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-017f74fe"]])

export default __exports__